import { createContext, type ReactNode } from 'react';

/*
 * The organisation picker every page header starts its filters with. The shell
 * fills it in, so a page rendered on its own (a test) needs no router for it.
 */
export const OrganisationFilterSlot = createContext<ReactNode>(null);
